
import { Phone, Mail, MapPin } from "lucide-react";
import InnovaImg from "../assets/wallpapers/pexels-nguyen-khuong-773309378-19140255.jpg";

export default function Contact() {
  return (
    <div
      className="relative min-h-screen flex items-center justify-center text-white"
      style={{
        backgroundImage: `url(${InnovaImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative z-10 max-w-3xl text-center p-8 bg-white/10 backdrop-blur-md rounded-2xl shadow-2xl">
        <h2 className="text-5xl font-extrabold mb-4 tracking-wide text-yellow-300">
          Contact Us
        </h2>
        <p className="text-lg mb-8 text-gray-200">
          We’re just a call away! Whether it’s a booking, query, or feedback —
          we’re here to help you anytime. Reach us through the details below.
        </p>

        <div className="space-y-6">
          <div className="flex items-center justify-center gap-3">
            <Phone className="text-yellow-400 w-6 h-6" />
            <p className="text-xl font-medium">+91 7717776192</p>
          </div>

          <div className="flex items-center justify-center gap-3">
            <Mail className="text-yellow-400 w-6 h-6" />
            <p className="text-xl font-medium">rishbh79799@gmail.com</p>
          </div>

          <div className="flex items-center justify-center gap-3">
            <MapPin className="text-yellow-400 w-6 h-6" />
            <p className="text-xl font-medium">
              Golmuri, Jamshedpur, Jharkhand - 03
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
